import { render, staticRenderFns } from "./ProvinceCityAreaWithoutTown.vue?vue&type=template&id=f94adad8&scoped=true&"
import script from "./ProvinceCityAreaWithoutTown.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaWithoutTown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94adad8",
  null
  
)

export default component.exports